import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import {
  FIGMA_COLUMN_FULL_WIDTH,
  FIGMA_COLUMN_GAP_FULL_WIDTH,
  FIGMA_COLUMN_GAP_MOBILE,
  FIGMA_COLUMN_WIDTH_MOBILE,
  FIGMA_MOBILE_SCREEN_WIDTH,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.figma';
import { calculateColumnsInScreen } from '@Utils/miscUtils';

export function isLargerThanBreakPoint(screenWidth: number) {
  return (
    screenWidth > FIGMA_COLUMN_FULL_WIDTH * 2 + FIGMA_COLUMN_GAP_FULL_WIDTH
  );
}

/** Calculates the number of columns and column and gap widths, so the screen always contains the maximum number of whole columns */
export function calculateColumnsAndGap(viewData: ViewData): ViewData {
  const { cameraProps } = viewData;
  const { width: screenWidth } = cameraProps.size;
  const calculatorFunc = isLargerThanBreakPoint(screenWidth)
    ? getNumOfColumnsLarge
    : getNumOfColumnsSmall;
  return { ...viewData, ...calculatorFunc(screenWidth) };
}

export function get2ColumnsWidth(viewData: ViewData) {
  return viewData.columnWidth! * 2 + viewData.columnGap!;
}
function getNumOfColumnsSmall(
  screenWidth: number
): Pick<ViewData, 'columnGap' | 'columnWidth' | 'layoutTable' | 'layoutWidth'> {
  // number of columns are always 2
  const columnWidth = Math.floor(
    (screenWidth * FIGMA_COLUMN_WIDTH_MOBILE) / FIGMA_MOBILE_SCREEN_WIDTH
  );
  const columnGap = Math.floor(
    (screenWidth * FIGMA_COLUMN_GAP_MOBILE) / FIGMA_MOBILE_SCREEN_WIDTH
  );
  const mainColumnWidth = columnWidth * 2 + columnGap;
  const layoutTable = [[], []];

  return {
    columnWidth,
    columnGap,
    layoutWidth: mainColumnWidth,
    layoutTable,
  };
}

export function getNumOfColumnsLarge(
  screenWidth: number
): Pick<ViewData, 'columnGap' | 'columnWidth' | 'layoutTable' | 'layoutWidth'> {
  const columnWidth = FIGMA_COLUMN_FULL_WIDTH;
  const columnGap = FIGMA_COLUMN_GAP_FULL_WIDTH;
  const numberOfWholeColumns = calculateColumnsInScreen(
    screenWidth,
    columnWidth,
    columnGap
  );
  const mainColumnWidth =
    columnWidth * numberOfWholeColumns + columnGap * (numberOfWholeColumns - 1);
  const layoutTable = Array.from({ length: numberOfWholeColumns }, () => []);

  return {
    columnWidth,
    columnGap,
    layoutWidth: mainColumnWidth,
    layoutTable,
  };
}
